// src/components/DownloadAppModal.js
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX, FiSmartphone } from 'react-icons/fi';
import '../styles/DownloadAppModal.scss';

const DownloadAppModal = ({ isOpen, onClose, feature = 'this feature' }) => {
  const handleDownload = () => {
    window.location.href = 'https://invits.co/app';
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="download-app-modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="download-app-modal-content"
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={onClose}>
              <FiX size={24} />
            </button>

            <div className="modal-icon">
              <FiSmartphone size={48} />
            </div>

            <h2>Download the Invits App</h2>
            <p>To use {feature}, please download the Invits mobile app.</p>

            <div className="modal-actions">
              <button className="download-btn" onClick={handleDownload}>
                Download App
              </button>
              <button className="cancel-btn" onClick={onClose}>
                Maybe Later
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default DownloadAppModal;
